import Component from './Component';
import React from 'react';
import {RxForm} from 'reactis-forms';
import {Loader} from 'reactis-loader';
import {connect} from 'react-redux';

@connect((state, props) => {
	return {
		formState: state.forms.get('tab_' + props.id)
	};
}, null, null, {withRef: true })
export default class AppForm extends React.Component {

	validate() {
		return this.refs.form.getWrappedInstance().validate();
	}

	render() {
		const loading = this.props.formState && this.props.formState.get('loading');

		return (
			<div className="form-container" style={{position:'relative'}}>
				<Loader visible={loading} />
				<RxForm ref="form" disableInitRedux={this.props.disableInitRedux} form={this.props.form} id={'tab_' + this.props.id}>
					{this.props.children}
				</RxForm>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/AppForm.js